// SPA analytics (best-practice §10): gtag('config') only fires a pageview on first
// load — client route changes (pushState) must send page_view manually, or GA only
// ever sees the homepage. Also tag Clarity sessions with lang/mode for segmentation.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    clarity?: (...args: unknown[]) => void;
  }
}

export function trackPageview(lang: string, mode: string): void {
  window.gtag?.('event', 'page_view', {
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
  window.clarity?.('set', 'lang', lang);
  window.clarity?.('set', 'mode', mode);
}
